
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { Collection } from "@/lib/api/types";
import { useQueryClient } from "@tanstack/react-query";
import { deleteCollection } from "@/lib/api/collections";

export const useCollectionManagement = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const handleCollectionSelect = (id: string) => {
    // Only navigate if we're not already on this route
    const currentPath = window.location.pathname;
    const targetPath = `/collections/${id}`;
    if (currentPath !== targetPath) {
      navigate(targetPath);
    }
  };

  const handleCollectionEdit = (collection: Collection) => {
    // This will be handled by the CollectionManagement component
    console.log('Editing collection:', collection.id);
  };

  const handleDelete = async (collection: Collection) => {
    console.log('Starting delete process for specific collection:', collection);
    
    // Validate collection data before deletion
    if (!collection || !collection.id || !collection.name) {
      console.error('Invalid collection data provided for deletion');
      toast({
        title: "Error",
        description: "Invalid collection data. Cannot delete collection.",
        variant: "destructive",
      });
      return;
    }
    
    try {
      console.log(`Deleting collection: ${collection.name} (${collection.id})`);
      
      await deleteCollection(collection);
      
      await queryClient.invalidateQueries({ queryKey: ["collections"] });
      await queryClient.invalidateQueries({ 
        queryKey: ["productDescriptions", collection.id] 
      });
      
      toast({
        title: "Success",
        description: `Collection "${collection.name}" deleted successfully`,
      });
      
      // Navigate to collections page after successful delete
      navigate("/collections");
    } catch (error) {
      console.error('Delete error:', error);
      toast({
        title: "Error",
        description: `Failed to delete collection "${collection.name}"`,
        variant: "destructive",
      });
    }
  };

  return {
    handleCollectionSelect,
    handleCollectionEdit,
    handleDelete,
  };
};
